import { ReactNode } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { OrganizationProvider } from './contexts/OrganizationContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ConfigProvider } from './contexts/ConfigContext';

/**
 * Combines all context providers into a single component.
 * This reduces the React fiber tree depth, which is critical for
 * iOS Safari compatibility in dev mode (Safari has a much smaller
 * call stack than Chrome; React 19 dev mode uses recursive tree traversal).
 */
export function AppProviders({ children }: { children: ReactNode }) {
    return (
        <ThemeProvider>
            <AuthProvider>
                <OrganizationProvider>
                    <NotificationProvider>
                        <PermissionsProvider>
                            <ConfigProvider>
                                <LanguageProvider>
                                    {children}
                                </LanguageProvider>
                            </ConfigProvider>
                        </PermissionsProvider>
                    </NotificationProvider>
                </OrganizationProvider>
            </AuthProvider>
        </ThemeProvider>
    );
}
